import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { translate } from 'react-i18next'

/* Utilities */
import { filterAndSort } from 'util/list'

/* Components */
import PlaylistItem from './item'
import CreatedItem from './created'

/* Widgets */
import SearchInput from 'widget/search-input'
import { Icon, ICON, SCHEME as ICON_SCHEME } from 'widget/icon'
import SortToolbar from 'widget/sort-toolbar'

/* Actions */
import { showModal, hideModal } from 'react-redux/actions/modal'
import {
  fetchItems,
  saveFilter,
  fetchFilter,
  fetchSort,
  saveSort,
  nextPage
} from 'react-redux/actions/playlist'
import {
    createItem,
    createPlaylistFromAsset,
    createEmptyPlaylist,
} from 'react-redux/actions/playlist'

/* Selectors */
import { getDragAndDrop } from 'react-redux/selectors/drag-and-drop'

import selector from './selector'

/* Styles */
import './list.css'

class PlaylistList extends Component {

    constructor(props) {
      super(props)
      this.state = {
        isDropTarget: false,
        showBackToTop: false
      }
      this.dragEnterCount = 0
    }

    componentDidMount() {
      const { fetchFilter, fetchSort, filter, sort } = this.props
      if (!filter.initialized) fetchFilter()
      if (!sort.initialized) fetchSort()
      window.addEventListener("resize", this.loadMore.bind(this))
    }

    componentWillUnmount() {
      window.removeEventListener("resize", this.loadMore.bind(this));
    }

    componentWillReceiveProps(nextProps) { }

    componentDidUpdate() {
      const {
        fetchItems,
        pagination,
        maxResults,
        fetchingList,
        filter,
        globalFilter,
        query,
        sort
      } = this.props
      const initialized = filter.initialized
        && globalFilter.initialized
        && sort.initialized
      const filterString = _.compact(
        [filter.expression, globalFilter.expression]
      ).join(" ")
      const resultChange = filterString !== query.filter
        || sort.field !== query.sort_by_field
        || sort.reverse[sort.field] != query.reverse_order
      const shouldLoad = resultChange || pagination.page !== query.page

      if (initialized && !fetchingList) {
        if (shouldLoad) {
          fetchItems(
            {
              filter: filterString,
              page: resultChange ? 0: pagination.page
            }
          )
        } else {
          this.loadMore()
        }
      }
    }

    onPlaylistAdd() {
        const { t, createEmptyPlaylist } = this.props
        createEmptyPlaylist(t('playlist:list.newPlaylistName'))
    }

    filterPlaylists(value) {
        const { saveFilter } = this.props
        saveFilter(value)
    }

    resetFilter(e) {
        const { saveFilter } = this.props
        saveFilter("")
    }

    /* Drag & Drop */

    onDragEnter(e) {
        const { domain } = this.props.dragAndDrop
        this.dragEnterCount++
        e.preventDefault()
        e.stopPropagation()
        if (domain === "asset") this.setState({isDropTarget: true})
        else this.setState({isDropTarget: false})
    }

    onDragOver(e) {
        e.preventDefault()
        e.stopPropagation()
    }

    onDragLeave(e) {
        e.preventDefault()
        e.stopPropagation()
        if(this.dragEnterCount) this.dragEnterCount--
        if (!this.dragEnterCount) this.setState({isDropTarget: false})
    }

    onDrop(e) {
        const { uid, createPlaylistFromAsset } = this.props
        e.preventDefault()
        e.stopPropagation()
        try {
            const data = JSON.parse(e.dataTransfer.getData('text'))
            if(data.domain === "asset") {
                createPlaylistFromAsset(data.uid)
            }
        } catch (e) {
            return
        }
        this.dragEnterCount = 0
        this.setState({isDropTarget: false})
    }

    loadMore() {
      const { pagination, nextPage } = this.props
      if (
        !pagination.reachedEnd
        && (
          this.listBody
          && this.listElem
          && (this.listBody.clientHeight + 200) >= this.listElem.scrollHeight - this.listBody.scrollTop
        )
      ) {
        nextPage()
      }
    }

    onScroll(e) {
      if (!this.state.showBackToTop && this.listBody.scrollTop > 0)
          this.setState({ showBackToTop: true })
      else if (this.state.showBackToTop && this.listBody.scrollTop == 0)
          this.setState({ showBackToTop: false })
      this.loadMore()
    }

    onBackToTopClick(e) {
        this.listBody.scrollTop = 0
    }

    onScrollToSelectedClick(e) {
        var elements = this.listBody.querySelectorAll("li.playlist-item.component")
        var pos = 0
        for(var i = 0; i < elements.length; i++) {
          const offset = elements[i].offsetTop
          if(offset < this.listBody.scrollTop)
            pos = Math.max(pos, offset)
        }
        this.listBody.scrollTop = pos
    }

    onSortSelect(field, reverse) {
      const { sort, saveSort } = this.props
      let r = Object.assign({}, sort.reverse)
      r[field] = reverse
      saveSort({ field, reverse: r })
    }

    /* Helpers */

    getItemClass() {
      const { isDropTarget } = this.state
      var className = "playlist-list component column-list"
      if (isDropTarget) className += " drop-target"
      return className
    }

    /* Rendering */

    renderPlaceholder() {
      const { filter, list, t } = this.props
      if(list.length) return null
      let text
      if (filter.expression === "") text = t("playlist:list.empty.noItems")
      else text = t("playlist:list.empty.noResults")
      return <div className="placeholder">{ text }</div>
    }

    /**
    * Show a Placeholder if no assets are available
    */
    renderCreatedSectionHeadline() {
      const { t } = this.props
      return (
        <div
          key="create-section-headline"
          className="section-headline"
        >
          <span className="wrapper">{ t("playlist:list.created.sectionHeadline") }</span>
        </div>
      )
    }

    /**
    * Render Asset Items as list elements
    */
    renderCreatedItems() {
      const { createdList } = this.props
      return (
        _.map(createdList, (item) => {
          return <CreatedItem tid={ item } key={ item }/>
        })
      )
    }

    renderCreatedSection() {
      const { createdList } = this.props
      if (createdList.length) {
        return (
          <li>
            { this.renderCreatedSectionHeadline() }
            <ul className="created-section">
              { this.renderCreatedItems() }
            </ul>
          </li>
        )
      }
      return null
    }

    renderPlaylistItems() {
      const { list } = this.props
      return (
        _.map(list, (item) => {
            return <PlaylistItem uid={ item } key={ item }/>
        })
      )
    }

    renderSortToolbar() {
      const {
        t,
        sort
      } = this.props
      const items = [
        {
          name: "name",
          reverse: sort.reverse.name,
          label: t("playlist:list.sort.name"),
          selected: sort.field === "name"
        },
        {
          name: "timeCreated",
          reverse: sort.reverse.timeCreated,
          label: t("playlist:list.sort.timeCreated"),
          selected: sort.field === "timeCreated"
        },
        {
          name: "timeModified",
          reverse: sort.reverse.timeModified,
          label: t("playlist:list.sort.timeModified"),
          selected: sort.field === "timeModified"
        },
      ]

      return (
        <SortToolbar
          items={ items }
          onSelect={ this.onSortSelect.bind(this) }
        ></SortToolbar>
      )
    }

    renderBackToTop() {
        if(this.state.showBackToTop) return (
          <div className="back-to-top">
            <Icon
              icon={ ICON.SCROLL_TO_TOP }
              scheme={ ICON_SCHEME.ACTION }
              size={ 32 } circle={ true }
              interactive={ true }
              onClick={ this.onBackToTopClick.bind(this) }
            />
            <Icon
              icon={ ICON.SCROLL_TO_SELECTED }
              scheme={ ICON_SCHEME.ACTION }
              size={ 32 }
              circle={ true }
              interactive={ true }
              onClick={ this.onScrollToSelectedClick.bind(this) }
            />
          </div>
        )
        return null
    }

    renderNextPage() {
      const { pagination, nextPage, t } = this.props
      if (!pagination.reachedEnd) {
        return (
          <li key="pagination-helper" className="pagination-helper" onClick={ nextPage.bind(this) }>
            <div className="spinner">
              <Icon
                icon={ ICON.LOADING_SYNC }
                scheme={ ICON_SCHEME.ACTION }
                size={ 32 } circle={ true }
                interactive={ true }
                spin={ true }
                interactive={ true }
              />
            </div>
            <div className="caption">
              { t("playlist:list.pagination.loading") }
            </div>
          </li>
        )
      }
      return null
    }

    render() {
        const { t, filter } = this.props
        return (
            <div
                className={ this.getItemClass() }
                onDragEnter={ this.onDragEnter.bind(this) }
                onDragOver={ this.onDragOver.bind(this) }
                onDragLeave={ this.onDragLeave.bind(this) }
                onDrop={ this.onDrop.bind(this) }
            >
                <div className="header">
                  <h2>{ t("playlist:list.headline") }</h2>
                  <button
                    className="icon"
                    title={ t("playlist:list.createNewPlaylist") }
                    onClick={ this.onPlaylistAdd.bind(this) }>
                    <Icon
                      icon={ ICON.ADD }
                      size={ 24 }
                      circle={ true }
                      interactive={ true }
                    />
                  </button>
                </div>
                <div className="filter-input-wrapper">
                  <SearchInput
                     className="filter-input"
                     type="text"
                     onChange={ this.filterPlaylists.bind(this) }
                     onReset={ this.resetFilter.bind(this) }
                     value={ filter.expression }
                     placeholder={t("playlist:list.searchInput.placeholder")}
                  />
                </div>
                { this.renderSortToolbar() }
                <div className="body"
                   ref={ (ref) => { this.listBody = ref } }
                   onScroll={ this.onScroll.bind(this) }
                 >
                    <ul
                      className="list"
                      ref={ (ref) => { this.listElem = ref } }
                    >
                      { this.renderCreatedSection() }
                      { this.renderPlaceholder() }
                      { this.renderPlaylistItems() }
                      { this.renderNextPage() }
                    </ul>
                </div>
                { this.renderBackToTop() }
            </div>
        )
    }
}

PlaylistList.propTypes = {}

const mapStateToProps = (state, props) => selector(state)

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      saveSort,
      fetchSort,
      fetchItems,
      createItem,
      showModal,
      createPlaylistFromAsset,
      createEmptyPlaylist,
      saveFilter,
      fetchFilter,
      nextPage
    },
    dispatch
  )
}

const reduxComponent = connect(mapStateToProps, mapDispatchToProps)(PlaylistList)
export default translate([], { withRef: true })(reduxComponent)



// WEBPACK FOOTER //
// ./src/app/component/playlist/list.jsx